import trim from 'lodash/trim';
import { useMemo, useState } from 'react';
import { useChatSettings, useDetectIframe, ChatAPI } from '@guuru/chat-web';

const useTheme = function (partnerId: string) {
  const inIframe = useDetectIframe();
  const [isFullScreen, setFullScreen] = useState(!inIframe);

  const {
    data: {
      chatSettings: {
        organization,
        chatWidgetPrimaryColor,
        chatWidgetCustomBackground,
        chatWidgetCustomBackgroundPhotoUrl,
        chatWidgetFont,
        smartFormAlignment = 'center',
      } = {},
    } = {},
    loading,
  } = useChatSettings(partnerId);

  const fontFamily = useMemo(
    () =>
      trim(chatWidgetFont ?? undefined) && chatWidgetFont !== 'system-ui'
        ? 'PartnerFont'
        : undefined,
    [chatWidgetFont],
  );

  if (!partnerId || (!chatWidgetPrimaryColor && !organization) || loading) {
    return { loading };
  }

  const chatLayout = !window.location.pathname.includes('/form');
  let chatAlignment = 'center';
  if (!chatLayout) {
    chatAlignment = isFullScreen ? 'center' : (smartFormAlignment ?? 'center');
  }
  return {
    loading,
    fontFamily,
    chatLayout,
    chatAlignment,
    isFullScreen,
    setFullScreen,
    color: chatWidgetPrimaryColor || organization?.color,
    colorScheme: organization ? 'Classic' : 'Clean',
    backgroundUrl:
      chatWidgetCustomBackground && chatWidgetCustomBackgroundPhotoUrl,
    header: ChatAPI.storeRetrieveParams().header !== 'false',
  };
};

export default useTheme;
